import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { InGameCurrency } from '@sorare/core/src/__generated__/globalTypes.ts';
import { isType, withFragments } from '@sorare/core/src/lib/gql/index.ts';

import type { getBoostedAlternative_anyRewardConfigInterface } from './__generated__/getBoostedAlternative.graphql.ts';

export const getBoostedAlternative = withFragments(
  (
    rewardConfigs: readonly getBoostedAlternative_anyRewardConfigInterface[]
  ): 'marketCredit' | 'commonGems' | null => {
    const [firstRewardConfig] = rewardConfigs;

    if (!firstRewardConfig) return null;

    if (isType(firstRewardConfig, 'ConversionCreditRewardConfig')) {
      return 'marketCredit';
    }

    if (
      isType(firstRewardConfig, 'InGameCurrencyRewardConfig') &&
      firstRewardConfig.currency === InGameCurrency.COMMON_GEM
    ) {
      return 'commonGems';
    }

    return null;
  },
  {
    anyRewardConfigInterface: gql`
      fragment getBoostedAlternative_anyRewardConfigInterface on AnyRewardConfigInterface {
        id
        ... on InGameCurrencyRewardConfig {
          id
          currency
        }
      }
    ` as TypedDocumentNode<getBoostedAlternative_anyRewardConfigInterface>,
  }
);
